import React, { Component } from 'react'
import {
  Button,
  WhiteSpace,
  WingBlank,
  InputItem,
  Flex,
  Toast,
} from 'antd-mobile'
import company_logo from '../../assets/images/admin_logo.png'
import './login.scss'
import http from '../../utils/request'
import { setLoginUid, setSessionSecretKey } from '../../utils/auth-storage'

export class Login extends Component {
  state = {
    loading: false,
    username: '',
    password: '',
    versionTapCount: 0,
  }
  onTapVersion = () => {
    const now = Date.now()
    const inWindow = now - (this.versionTapAt || 0) < 3000
    const nextCount = inWindow ? this.state.versionTapCount + 1 : 1
    this.versionTapAt = now
    this.setState({ versionTapCount: nextCount })
    if (nextCount >= 10) {
      this.setState({ versionTapCount: 0 })
      sessionStorage.setItem("vconsole-open", "1")
      document.documentElement.classList.add("vconsole-open")
      if (window.vConsole && typeof window.vConsole.showSwitch === "function") {
        window.vConsole.showSwitch()
      }
      Toast.info("调试面板已开启", 1.5)
    }
  }
  onChangeUserName = value => {
    console.log(value)
    this.setState({
      username: value
    })
  }
  onChangePassword = value => {
    console.log(value)
    this.setState({
      password: value
    })
  }
  validateInfo = () => {
    return new Promise(rev => { })
  }
  onLoginBtn = () => {
    const { username, password } = this.state
    if (!username) {
      Toast.info('请填写用户名！', 2)
      return
    }
    if (!password) {
      Toast.info('请填写密码！', 2)
      return
    }
    this.setState({
      loading: true
    })

    http.post('/auth/open/login', {
      loginName: username,
      password: password
    }, 'new').then(res => {
      console.log(res)
      this.setState({
        loading: false
      })
      if (res) {
        if (res.data && res.status == 200) {
          sessionStorage.setItem('loginMsg', JSON.stringify(res.data))
          sessionStorage.setItem('adminType', JSON.stringify(5))
          sessionStorage.setItem('manager-web-session', res.data["manager-web-session"])
          sessionStorage.setItem('pc-access-token', res.data["token"])
          if (res.data.sessionSecretKey) {
            setSessionSecretKey(res.data.sessionSecretKey)
          }
          if (res.data.loginUser && res.data.loginUser.uid != null) {
            setLoginUid(res.data.loginUser.uid)
          }
          this.getAdminInfo(res.data.loginUser)
        } else {
          Toast.info(res.message, 2)
        }
      }
    })
    .catch(() => {
      this.setState({
        loading: false
      })
    })
  }
  async getAdminInfo(loginUser) {
    let preferentialMonths = 0;
    let userValidYears = 0;
    let permissionCodeList = [];
    //获取设置优惠年限
    await http.get("/api/user/admin/preferentialMonths/get", {}, 'new')
      .then(res => {
        if (res.status == 200 && res.data) {
          preferentialMonths = res.data;
        }
      })
    //获取账号有效年限
    await http.get("/api/user/admin/validYears/get", {}, 'new')
      .then(res => {
        if (res.status == 200 && res.data) {
          userValidYears = res.data;
        }
      })
    //获取管理员权限
    await http.get("/api/admin/permission/find/adminId", {
        adminId: loginUser.id
      }, 'new')
      .then(res => {
        if (res.status == 200 && res.data) {
          permissionCodeList = res.data.map(item => item.code);
        }
      })
    sessionStorage.setItem(
      "loginMsg",
      JSON.stringify({ ...loginUser, preferentialMonths, userValidYears, permissionCodeList }),
    )
    Toast.info("登录成功", 2);
    window.location.reload();
  }
  render() {
    return (
      <div className="login">
        <WingBlank>
          <div className="login-top">
            <Flex justify="center">
              <img src={company_logo} alt="" />
            </Flex>
            <Flex justify="center">
              <h2>铁通集团对讲管理平台</h2>
            </Flex>
          </div>
          <div className="middle">
            <div className=" middle-info">
              <InputItem
                onChange={this.onChangeUserName}
                clear
                placeholder="用户名"
              />
            </div>
            <div className=" middle-info">
              <InputItem
                onChange={this.onChangePassword}
                clear
                type="password"
                placeholder="密码"
              />
            </div>
          </div>
          <div className="bottom">
            <Button
              loading={this.state.loading}
              disabled={this.state.loading}
              type="primary"
              onClick={this.onLoginBtn}
            >
              登录
            </Button>
          </div>
          <WhiteSpace />
          <WhiteSpace />
          <div>
            <Flex justify="center">
              <span className="login-version" onClick={this.onTapVersion}>
                {window.CONFIG_URL2 && window.CONFIG_URL2.version}
              </span>
            </Flex>
          </div>
          <div className="login-beian">
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
            >
              闽ICP备19020437号
            </a>
          </div>
        </WingBlank>
      </div>
    )
  }
}

export default Login
